import actions from './actions'
import {RequestService as req} from "../../../services/requestService";
import { Constants } from "../../../config/constants";
import {fetchSectionStudents} from "../all-students/actionCreator";

const { fetchStudentsAction } = actions;

export const fetchStudentsForIDCard = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.STUDENTS}card`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchStudentsAction(cb)))
    };
};

export const updateParentsIDCardPrint = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.ACADEMIC}parent/id-card/print/`,
            body: data.coordinationValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchStudentsForIDCard(data.filters))
            if (action) await action();
        })
    };
};

export const updateStudentIDCardPrint = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.ACADEMIC}student/id-card/print/`,
            body: data.coordinationValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchStudentsForIDCard(data.filters))
            if (action) await action();
        })
    };
};

export const updateStudentPhotoSubmit = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.ACADEMIC}student/photo`,
            body: data.coordinationValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchStudentsForIDCard(data.filters))
            if (action) await action();
        })
    };
};
